<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.situacao') }}:
                |
                | {{ getSituacao(restricao.situacao) || '-' }}
                Criticidade(
                    v-if='restricao.nivelAlerta'
                    :restricao='restricao'
                )
</template>

<script>
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'situacao-car-santander',

    emits: ['highlightGeometry'],

    data() {
        return {};
    },

    components: {
        Criticidade,
        BaseButton
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        getSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.ativo'
                    );
                case 'PE':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.pendente'
                    );
                case 'SU':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.suspenso'
                    );
                case 'CA':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.situacoes.cancelado'
                    );
                
            }
        },
        aplicarZoomRestricao(index) {
            if (this.restricaoSelecionadaZoomIndex !== index) {
                this.restricaoSelecionadaZoomIndex = index;
                let geometriaQueNaoEstavaDentroDasRestricoes = null;
                if (this.geometria) {
                    geometriaQueNaoEstavaDentroDasRestricoes =
                        this.geometria[index];
                }
                this.$emit(
                    'aplicar-zoom-restricao',
                    this.restricoes[index],
                    geometriaQueNaoEstavaDentroDasRestricoes
                );
            } else {
                this.restricaoSelecionadaZoomIndex = '';
                this.$emit('aplicar-zoom-restricao', null, null);
            }
        }
    }
};
</script>
